import { t } from 'i18next'
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const InvoiceSearchPage = lazy(() => import('../containers/InvoiceSearch/InvoiceSearchContainer'))
const InvoiceSearchDocumentPage = lazy(() => import('../containers/InvoiceSearch/InvoiceSearchDocumentContainer'))

export const INVOICE_SEARCH_PATHS = {
  HOME: '/invoices-search',
  INVOICE_PDF: (invoiceNumber?: number) => `/invoices-search/get-document/${invoiceNumber ? invoiceNumber : ':invoiceNumber'}`,
} as const

export const invoiceSearchRoutes: RouteObject[] = [
  {
    path: INVOICE_SEARCH_PATHS.HOME,
    children: [
      {
        index: true,
        element: <InvoiceSearchPage />,
        handle: {
          crumb: (): MenuItem[] => [
            { label: t('general:menu.invoices_search') || '', url: INVOICE_SEARCH_PATHS.HOME },
          ],
        },
      },
      {
        path: INVOICE_SEARCH_PATHS.INVOICE_PDF(),
        element: <InvoiceSearchDocumentPage />,
      },

    ],
  },
]
